import isWithinInterval from 'date-fns/isWithinInterval';
import {
  ECategoryType,
  IApiEligibleCategories,
  IPassCategory,
} from './eligible-categories.types';

export const getPassCategory = (eligibleCategories: IApiEligibleCategories) =>
  eligibleCategories.attributes.categories.find(
    ({ id }) => id === ECategoryType.PASS
  ) as IPassCategory | undefined;

export const getActiveSpecialOffer = (
  passCategory: IPassCategory,
  currentDate: Date | string
) =>
  passCategory.specialOffers.find(specialOffer =>
    isWithinInterval(currentDate, {
      start: specialOffer.startDate,
      end: specialOffer.endDate,
    })
  );
